<template>
  <Teleport to="body">
    <div v-if="modelValue" class="sa-modal" @keydown.esc="dismiss">
      <div class="sa-modal__backdrop" @click="dismiss" />
      <div
        class="sa-modal__panel"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        :style="{ maxWidth }"
      >
        <h2 :id="titleId" class="sa-modal__title">{{ title }}</h2>
        <div class="sa-modal__body">
          <slot />
        </div>
        <div class="sa-modal__actions">
          <button
            v-if="cancelLabel"
            type="button"
            class="sa-modal__btn sa-modal__btn--cancel"
            :disabled="disabled"
            @click="close"
          >
            {{ cancelLabel }}
          </button>
          <button
            type="button"
            class="sa-modal__btn sa-modal__btn--confirm"
            :disabled="disabled"
            @click="confirm"
          >
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
let titleSeq = 0;

export default {
  name: 'SaConfirmModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      default: 'Confirmar',
    },
    cancelLabel: {
      type: String,
      default: '',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: '480px',
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  data() {
    titleSeq += 1;
    return {
      titleId: `sa-modal-title-${titleSeq}`,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(open) {
        document.body.style.overflow = open ? 'hidden' : '';
      },
    },
  },
  beforeUnmount() {
    document.body.style.overflow = '';
  },
  methods: {
    dismiss() {
      if (this.persistent) return;
      this.close();
    },
    close() {
      this.$emit('update:modelValue', false);
      this.$emit('cancel');
    },
    confirm() {
      this.$emit('confirm');
      this.$emit('update:modelValue', false);
    },
  },
};
</script>

<style scoped>
.sa-modal {
  position: fixed;
  inset: 0;
  z-index: 4000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
}

.sa-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
}

.sa-modal__panel {
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.16);
  text-align: left;
}

.sa-modal__title {
  margin: 0;
  padding: 1.25rem 1.25rem 0.35rem;
  color: #1f2937;
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.35;
}

.sa-modal__body {
  padding: 0.35rem 1.25rem 0.25rem;
  color: #4b5563;
  font-size: 0.9375rem;
  line-height: 1.5;
}

.sa-modal__body :deep(p) {
  margin: 0 0 0.75rem;
}

.sa-modal__body :deep(p:last-child) {
  margin-bottom: 0;
}

.sa-modal__actions {
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.25rem 1.25rem;
}

.sa-modal__btn {
  flex: 1;
  min-height: 44px;
  border: none;
  border-radius: 8px;
  padding: 0.7rem 1rem;
  font-family: inherit;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
}

.sa-modal__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sa-modal__btn--cancel {
  background: #eceff3;
  color: #1f2937;
}

.sa-modal__btn--cancel:hover:not(:disabled) {
  background: #e2e5ea;
}

.sa-modal__btn--confirm {
  background: #250891;
  color: #fff;
  box-shadow: 0 2px 4px rgba(37, 8, 145, 0.2);
}

.sa-modal__btn--confirm:hover:not(:disabled) {
  background: #1f0770;
}
</style>
